<template>
  <v-btn
      @click="onClick"
      icon
      tile
      elevation="2"
      v-bind="$attrs"
  >
    <v-icon small v-if="flag">{{onIcon}}</v-icon>
    <v-icon small v-else>{{offIcon}}</v-icon>
  </v-btn>
</template>

<script>

export default {
  name: 'BaseIconSwitch',
  inheritAttrs: false,
  props: {
    value: {default: null},
    onIcon: {default: null},
    offIcon: {default: null},
  },

  components: {},

  computed: {
  },

  methods: {
    onClick(event) {
      // console.log('onClick', event)
      this.flag = !this.flag
      this.$emit('input', this.flag)
    },
  },

  async mounted() {

  },

  data() {
    return {
      flag: this.value
    }
  }
}
</script>

<style scoped lang="scss">
</style>
